import { mapState } from "vuex";
export const deviceManageIndexMixins = {
  computed: {
    deviceManageTopBarList() {
      let topbarList = [
        {
          name: "设备管理",
          isActive: false,
          path: "/devicemanage/deviceList",
          icon:require("@/assets/img/menuIcons/icon-devicemanagedeviceList.png")
        },
        {
          name: "收款码管理",
          isActive: false,
          path: "/devicemanage/moneyCodeList",
          icon:require("@/assets/img/menuIcons/icon-devicemanagemoneyCodeList.png")
        },
        {
          name: "收款码会员买单",
          isActive: false,
          path: "/devicemanage/moneyCodeMemberPay",
          icon:require("@/assets/img/menuIcons/icon-devicemanagemoneyCodeMemberPay.png")
        },
        {
          name: "云音响防逃单",
          isActive: false,
          path: "/devicemanage/moneyCodeCloudSoundNoPay",
          icon:require("@/assets/img/menuIcons/icon-devicemanagemoneyCodeCloudSoundNoPay.png")
        },
      ];
      topbarList.forEach((val) => {
        if (val.path == this.$route.path) {
          val.isActive = true;
        }
        if (val.childrenPath) {
          if (~val.childrenPath.indexOf(this.$route.path)) {
            val.isActive = true;
          }
        }
      });
      return topbarList;
    },
  },
}
